import { Logo } from "./Logo";
import { Github, Linkedin, Twitter } from "lucide-react";

const LINKS = {
    "Solutions": [
        { label: "Local SEO", href: "https://local-seo.site/" },
        { label: "SMS Avis", href: "https://sms-avis.fr/" },
        { label: "PleskDash", href: "https://pleskdash.top/" },
        { label: "Bientôt…", href: "#cta" },
    ],
    "Société": [
        { label: "L'histoire", href: "#histoire" },
        { label: "Karedess Agency", href: "https://karedess.agency" },
        { label: "À propos de Sébastien", href: "https://karedess.agency/a-propos" },
        { label: "Contact", href: "mailto:info@karedess.agency" },
    ],
    "Ressources": [
        { label: "FAQ", href: "#faq" },
        { label: "Comment ça marche", href: "#process" },
        { label: "Avantages", href: "#avantages" },
        { label: "Newsletter", href: "#cta" },
    ],
};

export default function Footer() {
    return (
        <footer className="relative border-t border-border bg-card/30">
            <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6">
                <div className="grid gap-10 lg:grid-cols-12">
                    <div className="lg:col-span-5">
                        <Logo />
                        <p className="mt-5 max-w-sm text-sm leading-relaxed text-muted-foreground">
                            Web Me Up développe des outils SaaS simples et performants pour les agences web et les pros du marketing internet. Créés par des pairs, sur le terrain, en France.
                        </p>
                        <div className="mt-6 flex items-center gap-2">
                            <SocialLink href="https://twitter.com/schueller_seb" Icon={Twitter} label="Twitter" />
                            <SocialLink href="https://www.linkedin.com/company/innovation-karedess/" Icon={Linkedin} label="LinkedIn" />
                            <SocialLink href="https://karedess.agency" Icon={Github} label="Site" />
                        </div>
                        <div className="mt-6 inline-flex items-center gap-2 rounded-full border border-border bg-background/40 px-3 py-1.5 text-xs text-muted-foreground">
                            <span className="h-2 w-2 animate-pulse-glow rounded-full bg-success" />
                            Tous les services sont opérationnels
                        </div>
                    </div>

                    {Object.entries(LINKS).map(([title, items]) => (
                        <div key={title} className="lg:col-span-2">
                            <h4 className="font-display text-sm font-semibold uppercase tracking-wider text-foreground">{title}</h4>
                            <ul className="mt-4 space-y-2.5">
                                {items.map((i) => (
                                    <li key={i.label}>
                                        <a
                                            href={i.href}
                                            target={i.href.startsWith("http") ? "_blank" : undefined}
                                            rel={i.href.startsWith("http") ? "noopener noreferrer" : undefined}
                                            className="text-sm text-muted-foreground transition-colors hover:text-foreground"
                                        >
                                            {i.label}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>

                <div className="mt-14 flex flex-col items-center justify-between gap-3 border-t border-border pt-8 sm:flex-row">
                    <p className="text-xs text-muted-foreground">
                        © {new Date().getFullYear()} Web Me Up · Une initiative de Sébastien Schueller / Karedess (S3BO5 SARL — Mulhouse).
                    </p>
                    <div className="flex items-center gap-5 text-xs text-muted-foreground">
                        <a href="https://karedess.agency/mentions-legales" className="hover:text-foreground">Mentions légales</a>
                        <a href="#" className="hover:text-foreground">CGV</a>
                        <a href="#" className="hover:text-foreground">Confidentialité</a>
                    </div>
                </div>
            </div>
        </footer>
    );
}

const SocialLink = ({ href, Icon, label }) => (
    <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={label}
        className="flex h-9 w-9 items-center justify-center rounded-lg border border-border bg-card/40 text-muted-foreground transition-colors hover:border-primary/40 hover:bg-card hover:text-foreground"
    >
        <Icon className="h-4 w-4" />
    </a>
);
